export const getSafeURLSearchParams = (searchStr: string | Record<string, string>) => {
  const searchParams = new URLSearchParams();

  if (typeof searchStr === 'object') {
    Object.entries(searchStr).forEach(([key, value]) => {
      searchParams.append(key, value);
    });
  } else {
    if (searchStr.length === 0) {
      return searchParams;
    }

    searchStr
      .replace(/^\?/, '')
      .split('&')
      .forEach((pair) => {
        const [key, value] = pair.split('=');
        searchParams.append(key, value);
      });
  }

  return searchParams;
};

export const getPathWithParams = (
  path: string,
  params: Record<string, string | string[]>,
): string => {
  const nonNullParams = Object.entries(params).reduce(
    (acc, [key, value]) => {
      if (value) {
        if (Array.isArray(value)) {
          acc[key] = value.join(',');
        } else {
          acc[key] = value;
        }
      }
      return acc;
    },
    {} as Record<string, string>,
  );

  let queryString = '';
  Object.entries(nonNullParams).forEach(([key, value], index) => {
    if (index !== 0) {
      queryString += '&';
    }
    queryString += `${key}=${value}`;
  });
  return `${path}?${queryString}`;
};

// http://localhost:3000/app/inst/channel99_2/web-traffic-activity?w.vendorIds=vndr_linkedin_paid&w.metrics.visits=%5B1%2C%5D&w.inTam=true
// http://localhost:3000/app/inst/channel99_2/web-traffic-activity?w.vendorIds=vndr_linkedin_paid&w.metrics.visits=%5B1%2C%5D&w.inTam=true
